let Palestras = [
  {
    title: "Processo construtivo da parede de concreto e produtividade",
    instructor: "Lucas Ribeiro Camargo Mendes",
    institution: "MRV Engenharia",
    desc: `Processo construtivo da parede de concreto e produtividade.`,
    date: "09/05",
    time: '08:00-09:30',
    place: 'Auditório 3 (Área II)',
    
   },
  {
    title: "Mesa Bistrô URBS",
    instructor: "Karine de Souza Costa",
    institution: "URBS Connect",
    desc: "Mesa Bistrô URBS",
      
    date: "10/05",
    time: "19:00-20:30",
    place: 'Presencial: Hall de entrada da Área III',
      
   },
  {
    title: "Engenharia de Segurança no Agronegócio",
    instructor: "André Luiz Dias da Silva",
    institution: "DN Engenharia",
    desc: "A engenharia de segurança no Agronegócio é importante para garantir a segurança dos trabalhadores e do ambiente de trabalho, bem como para aumentar a eficiência e a produtividade das atividades agrícolas. Conta com planejamento de medidas de prevenção e controle de incêndios nas áreas de plantio e armazenamento de produtos agrícolas, Desenvolvimento de estratégias para prevenção de acidentes com máquinas agrícolas, Implantação de medidas de segurança alimentar, como a adoção de boas práticas agrícolas e o controle de qualidade dos alimentos produzidos, Projeto de instalações de armazenamento de produtos agrícolas seguras e eficientes, incluindo sistemas de ventilação e controle de temperatura.",
    date: "09/05",
    time: "08:00-09:30",
    place: "Auditório 2 (Área II)",
  },
  {
    title: "Controle fitossanitário em hortaliças",
    instructor: "Scheila Ronconi Da Rolt",
    institution: "Araguaia produtos agropecuários",
    desc: "Controle fitossanitário em hortaliças é o conjunto de medidas adotadas para proteger as plantas cultivadas de doenças, pragas e outros agentes que possam afetar sua saúde e qualidade. Essas medidas podem incluir a adoção de práticas culturais adequadas, como rotação de culturas e manejo do solo, o uso de defensivos agrícolas quando necessário e a adoção de estratégias de controle biológico e integrado de pragas. O objetivo do controle fitossanitário é garantir a saúde e a produtividade das plantas, bem como a segurança alimentar e a proteção do meio ambiente. Além disso, o controle fitossanitário também pode contribuir para a sustentabilidade da produção agrícola, reduzindo o uso de defensivos químicos e promovendo práticas preventivas e curativas mais sustentáveis e ecologicamente corretas."
    ,
    date: "08/05",
    time: "08:00-09:30",
    place: 'Auditório 2 (Área II)',
  },
  {
    title: "Uso de drones para liberação de macrobiológicos ",
    instructor: "Lorenzo Czepak Gaston e Ana Makowich ",
    institution: `Drones on Farm e MIP-UFG`,
    desc: `O uso de drones para liberação de macrobiológicos é uma técnica inovadora que tem sido cada vez mais utilizada na agricultura para controle biológico de pragas. Macrobiológicos são organismos vivos, como insetos, ácaros e nematoides, que são utilizados para o controle de pragas agrícolas, em substituição aos agrotóxicos.
    Os drones são utilizados para liberar os macrobiológicos nas áreas de cultivo de forma mais eficiente e precisa, em comparação com a liberação manual. Com o uso dos drones, é possível alcançar áreas de difícil acesso e distribuir os macrobiológicos de maneira uniforme, reduzindo o desperdício e aumentando a eficácia do controle biológico.
    Além disso, o uso de drones para liberação de macrobiológicos também pode reduzir os custos e o tempo necessários para a aplicação dos organismos de controle biológico, em comparação com as técnicas convencionais. A técnica também pode contribuir para a redução do uso de defensivos químicos e a promoção de práticas mais sustentáveis na agricultura.
    A tendência é que essa tecnologia se torne cada vez mais popular e acessível, com a evolução da tecnologia e a demanda por práticas mais sustentáveis na agricultura.
    `,
    date: "08/05",
    time: "10:00-11:30",
    place: "Auditório 2 (Área II)",
  },
  {
    title: "Durabilidade de Geossintéticos",
    instructor: "Jefferson Lins",
    institution: "Universidade de São Paulo",
    desc: `Durabilidade de Geossintéticos`,
    date: "09/05",
    time: "19:00-20:30",
    place: "Online: YouTube",
    link:"https://www.youtube.com/watch?v=8kJZoBHnn_4"
  
  },
  {
    title: "Aplicações geotécnicas e ambientais das geomembranas",
    instructor: "Maria Alejandra Aparicio Ardila",
    institution: "Nortene Plásticos",
    desc: `Atualmente, a geomembrana de Polietileno é o único tipo de geossintético exigido pelos órgãos ambientais para garantir a segurança na destinação dos resíduos gerados em diversos tipos de indústrias. É um material polimérico de baixíssima permeabilidade, que atua como barreira, impedindo a passagem de fluidos, gases e vapores. Está presente em todos os sistemas de impermeabilização, desde a barreira simples até a barreira composta. É utilizado em diferentes trabalhos hidráulicos para o armazenamento ou condução de água. Nesta palestra serão abordadas algumas aplicações da geomembrana de polietileno.`,
    date: "10/05",
    time: '10:00-11:30',
    place: "Auditório 2 (Área II)",
  },

  {
    title: "TI: Caminhos e oportunidades dentro de um mar de possibilidades",
    instructor: "Patrick Morais de Souza Lima",
    institution: "Gerente de Engenharia e Qualidade de Software na GFT Technologies",
    desc: `Atualmente, nós da área de TI, vivemos em um mundo de possibilidades e incertezas. Foi pensando nisso que trouxe o tema "TI: Caminhos e oportunidades dentro de um mar de possibilidades", que irá falar um pouco de como planejar e o que fazer para ter uma carreira promissora dentro da área que mais cresce mundialmente. Qual caminho seguir? Como escolher sua carreira? Como ser um profissional desejado pelas empresas de tecnologia? Tudo isso será discutido no dia 10/05. Nos vemos lá!`,
    date: "09/05",
    time: "20:30-22:00",
    place: "Auditório 1 (Área II)",
  },

  {
    title:"Concursos de Projeto",
    instructor: "Rangel Henrique Brandão Silva, Frederico André Rabelo e Guilherme de Andrade Bento",
    institution: "Rangel Henrique Brandão Silva - UEG e RGB Estúdio, Frederico André Rabelo - PUC Goiás, UFG e RGB Estúdio, Guilherme de Andrade Bento - PUC Goiás e RGB Estúdio",
    desc: `Abordagem dos concursos públicos de projetos de Arquitetura e Urbanismo, a partir da experiência do escritório RGB Estúdio.`,
    date: "09/05",
    time: "08:00-10:00",
    place: "Auditório 1 (Área II)",
  },
  {
    title: "Estudos de Impactos Urbanos e Engenharia de Tráfego",
    instructor: "Evelyn Cristine Moreira Soares",
    institution: "PUC Goiás",
    desc: `O que são os Estudos de Impactos – Ambiental (EIA), de Vizinhança (EIV) e de Trânsito (EIT), a importância dos conhecimentos específicos, atuação profissional, mercado de trabalho.`,
    date: "08/05",
    time: "19:00-20:30",
    place: "Auditório 3 (Área II)",
  },
  {
    title: "Sistema Agroflorestal Biodiverso no Cerrado: Princípios e Dinâmicas",
    instructor:"Dr. Bruno de Andrade Martins",
    institution: "IFGoiano - Campus de Hidrolândia",
    desc: `Os SAFs são sistemas agroflorestais biodiversos e possuem alta capacidade para melhorar o meio ambiente. São formados por plantios de diversas/diferentes espécies vegetais na mesma área e, ao mesmo tempo (consórcios). Nesses sistemas incluem-se árvores e arbustos nativos ou exóticos e culturas agrícolas de diferentes ciclos. 
    Um dos importantes serviços ambientais que esses sistemas proporcionam é a melhoria do microclima. Ou seja, tanto a temperatura do ar como a do solo ficam mais estáveis, mais agradáveis aos agricultores(as) e a todas as espécies vegetais cultivadas, bem como aos organismos nativos que vivem nos SAFs, os quais ajudam a melhorar a qualidade do solo e o equilíbrio biológico.
    Outro serviço ambiental destacável é a melhoria do ciclo da água, pois facilita a sua infiltração no solo, alimentando o lençol freático e, consequentemente, fortalecendo as nascentes e os mananciais superficiais de água.
    Vários estudos também mostram o aumento da fertilidade, estrutura e da vida do solo, melhorando a sua qualidade, reduzindo e até dispensando o uso de fertilizantes.
    Com o aumento do equilíbrio biológico nesses sistemas, ocorre baixo ataque de pragas e doenças nos cultivos agrícolas, tornando-se desnecessária a utilização de defensivos e, consequentemente, facilitando a viabilização da produção orgânica.
    `,
    date: "09/05",
    time: "10:00-11:30",
    place: "Auditório 2 (Área II)",
    },

  {
    title:"Como trabalhar no lugar mais bonito do mundo",
    instructor: "Rafael Gonçalves ",
    institution: "Butchart Gardens ",
    desc: `Butchart Gardens`,
    date: "08/05",
    time: "19:00-20:30",
    place: "Online",
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_NGJmNGQxNDQtOTQ0Yi00MDJjLTlhM2ItNzFkY2RmMjhmZTIz%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d"
  },

  /*{
    title: "Geossintéticos aplicados a Engenharia Civil.",
    instructor: "Jefferson Lins",
    institution: "Universidade de São Paulo",
    desc: `Geossintéticos aplicados a Engenharia Civil.`,
    date: "09/05",
    time: "19:00-20:30",
    place: "Online",
  },*/
  {
    title: "LION XPRO: DO BIM AO BEM INTELIGÊNCIA ARTIFICIAL APLICADA AO DESENVOLVIMENTO DE PROJETOS DE EDIFÍCIOS SUSTENTÁVEIS",
    instructor: "Dr. Leônidas Albano e Dra. Maria José Pereira Dantas",
    institution: `PUC Goiás`,
    desc: `Discussões com o time da startup Lion xPRO a respeito das possibilidades atuais de inovação tecnológica, a partir da aplicação de inteligência artificial a ferramentas de avaliação ambiental e energética integradas ao desenvolvimento de projetos de edifícios, contribuindo com processos evolutivos de metodologias BIM (Building Information Modeling) a conceitos BEM (Building Energy Model).`,
    date: '10/05',
      time: '07:15-08:45',
      place: 'Online',
      link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_ODNlNzUwMTItMGM3OS00NTczLThkYmEtNTM2ZjFiOGYxOWY4%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d"
    
  },
  {
    title: "PESQUISA E PÓS-GRADUAÇÃO NA ARQUITETURA, NO URBANISMO E NO DESIGN",
    instructor: "Deusa Maria Rodrigues Boaventura e Sandra Catharinne Pantaleão Resende",
    institution: "PUC Goiás",
    desc: `Discussões a respeito da realização de projeto de pesquisa e de cursos de pós-graduação ligados aos cursos da Escola Politécnica e de Artes.`,
    date: "09/05",
    time: "19:00-20:30",
    place: "Auditório 2 (Área II)",
  },
  
  {
    title: "Experimentações Editoriais ",
    instructor: "Lucia Bertazzo",
    institution: "Lisboa, Portugal",
    desc: `A palestra da egressa do curso de Design da PUC Goiás, Lucia Bertazzo, vai abordar sua trajetória com experimentações gráficas que busca a melhor forma de unir artes plásticas e literatura. Seu trabalho é transformar livros em verdadeiras obras de arte com uma série de edições que contam com uma grande pesquisa de materiais e a colaboração de dezenas de tipógrafos, impressores de gravuras ou serigrafias, marceneiros, artífices em acrílico ou aço, fabricantes de papéis artesanais, moldureiros...e importantes artesãos. `,
    date: "08/05",
    time: "10:00-11:30",
    place: "Online: YouTube",
    link: "https://www.youtube.com/watch?v=z-jTl09YYlI"
  },
  {
    title: "Projeto Pormade Móvel",
    instructor: "Representante da Pormade Portas ",
    institution: "Pormade Portas",
    desc: `Independente de onde você estiver, a Pormade vai até você! O projeto do Pormade Móvel tem como objetivo divulgar os produtos e serviços da empresa além das barreiras geográficas. O veículo passa por eventos de inúmeras cidades para que a comunidade local possa conhecer de perto o que a Pormade oferece ao mercado.
    O primeiro Showroom Móvel da Pormade estreou na “Feicon Batimat em 2019, depois dos comentários positivos sobre a novidade, a frota cresceu e os veículos passaram por vários eventos importantes e tradicionais de diferentes cidades, como Design Fair, Expoingá, Kiwi Fest, Feicon, High Design, Equipotel, ConstruSul, lojas de materiais de construção, entre outros.
    Ele apresenta em sua carroceria os modelos de portas da Pormade, as estampas dos papéis de parede, piso vinilico, rodapés e fechaduras. Além disso, mesas e cadeiras ficam dispostas próximas aos veículos para que os visitantes conversem com os especificadores e analisem os catálogos.
    A arquitetura dos veículos do projeto conta ainda com uma televisão, na qual vídeos sobre a cultura Pormade são exibidos durante as participações nas feiras.
    O Pormade Móvel participa de vários eventos, feiras e faz visitas aos seus parceiros como lojas, arquitetos, engenheiros e instaladores.
    `,
    date: "09/05",
    time: "09:00-10:30",
    place: "Auditório Marisa Roriz (Área III)",
  },

  {
    title: "Ai.rtista, uma imersão na construção da imagem digital através do Midjourney e suas barreiras no mercado da arte",
    instructor: "João Paulo de Morais Alves",
    institution: "PUC Goiás",
    desc: `A palestra "Ai.rtista: uma imersão na construção da imagem digital através do Midjourney e suas barreiras no mercado da arte" aborda o desafio dos artistas em construir uma imagem digital coerente e atraente, que possa ajudá-los a se destacar no mercado da arte. O palestrante apresenta o conceito de Midjourney, que é uma ferramenta que ajuda os artistas a desenvolverem sua marca pessoal e construírem uma presença online consistente e eficaz. No entanto, o palestrante também aborda as barreiras que os artistas enfrentam nesse processo, como a falta de conhecimento técnico em marketing digital e a dificuldade em conciliar a produção artística com a gestão da imagem digital. A palestra busca oferecer insights e dicas práticas para que os artistas possam superar essas barreiras e construir uma imagem digital sólida e impactante.`,
    date: "08/05",
    time: "08:00-09:30",
    place: "Online",
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_NGMxZDYzYTMtZWVhZS00ODFmLThhMjMtMjI4YmY2MmFhMDhi%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d"
  },
  {
    title: "CRÔNICAS DO IGPA",
    instructor: "Frederico Mael e Marcos Costa de Freitas",
    institution: "PUC Goiás",
    desc: `O IGPA possui um acervo muito vasto, para cada peça há uma história, às vezes uma aventura perigosa, às vezes uma história engraçada. Assim, parte da "vida" dos artefatos está nessas histórias que expandem os seus sentidos. Nessa proposta vamos valorizar as crônicas e expor algumas peças do acervo. 
    Faremos uma apresentação breve de alguns cortes de vídeos que retratam momentos de produção de registros do acervo. Os relatos das crônicas do trabalho de campo serão trabalhados ao longo da projeção.
    `,
    date: "09/05",
    time: "10:00-11:30",
    place: "Auditório 1 (Área II)",
  },
  {
    title:"A IMAGEM DOS POVOS ORIGINÁRIOS BRASILEIROS ",
    instructor: "José Alecrim e Marcos Costa de Freitas",
    institution: "Ciranda da Arte - Governo de Goiás e PUC Goiás",
    desc: `Roda de conversa sobre a representação dos povos originários brasileiros. Propõe-se um passeio rápido ao longo da história, cobrindo momentos chave do Brasil colônia até a atualidade. A representação iconográfica, arquétipos e os estereótipos produzidos dos povos originários. O tema será apresentado por duas pessoas na condição de coordenadores da roda de conversa. 
    `,
    date: "10/05",
    time: "08:00-09:30",
    place: "Auditório 3 (Área II)",
  },

  {
    title: "Transformação Digital e Tendências",
    instructor: "Aguinaldo Aragon Fernandes",
    institution: "Consultor independente",
    desc: `O Que é a Transformação Digital. As Novas Tecnologias e Tendências. Fazendo o Mapa da Transformação Digital. Avaliando a Maturidade da Transformação Digital. O Roadmap de Implementação. Transformação Digital no Poder Público.`,
    date: "08/05",
    time: "10:00-11:30",
    place: "Online",
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_NDZmYWQzODItZTY4NS00ZWQxLWIwNjktOTgwMTAyNjE0YTky%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d"
  },
  {
    title: "Oficina Damata - Design e marcenaria tradicional",
    instructor: "Thiago da Mata Santos",
    institution: "Oficina Damata",
    desc: `A Oficina Damata é uma marcenaria com foco em trabalhos em madeira, não uma Indústria. Aqui as peças são produzidas a partir de técnicas de marcenaria tradicional. Penso em peças que tragam conexão! Desejo que a textura, a cor, o cheiro, de cada cadeira, banco ou mesa, que você se sentará para sua refeição ou trabalho, te levem a vivências e lembranças.`,
    date: "10/05",
    time: "10:00-11:30",
    place: "Auditório 3 (Área II)",
  },

  {
    title: "Inteligências Artificiais Generativas: impactos e oportunidades",
    instructor: "Weber Martins",
    institution: "PUC Goiás",
    desc: `Explorar-se-á a evolução, implicações sociais e éticas, além das oportunidades e desafios das Inteligências Artificiais Generativas, apresentando reflexões importantes para a área de Engenharia de Computação.`,
    date: "09/05",
    time: "10:00-11:30",
    place: "Auditório 3 (Área II)",
  },

  {
    title: "Modelos confiáveis gerados automaticamente por aprendizado de múltiplas bases de dados heterogêneas: exemplos de aplicações em Insegurança Alimentar, Risco de Crédito e Projeto de Injetores",
    instructor: "Dr. Alexandre Delbem",
    institution: "ICMC USP São Carlos",
    desc: `Modelos confiáveis gerados automaticamente por aprendizado de múltiplas bases de dados heterogêneas: exemplos de aplicações em Insegurança Alimentar, Risco de Crédito e Projeto de Injetores`,
    date: "08/05",
    time: "19:00-20:30",
    place: "Online",
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_YTQ4ZDUyYTYtMjI2MC00NDI0LWE0ZTQtY2M5NzA1M2U2ZjNj%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d"
  },

  {
    title: "Cidades Inteligentes e Sustentáveis: Ferramentas e Desafios",
    instructor: "Raphael de Aquino Gomes",
    institution: "Instituto Federal de Educação, Ciência e Tecnologia de Goiás (IFG)",
    desc: `O crescimento populacional desordenado, a poluição, a mudança climática e a falta de infraestrutura adequada têm impactos significativos no meio ambiente e na qualidade de vida em centros urbanos. Diante desse cenário, o conceito de cidades inteligentes e sustentáveis surge como uma abordagem promissora para resolver os problemas destes centros, utilizando tecnologias inovadoras, planejamento inteligente e uma visão integrada para melhorar a qualidade de vida dos moradores e proteger o meio ambiente. Nesta perspectiva, esta palestra busca apresentar as ferramentas e desafios envolvidos no desenvolvimento de cidades inteligentes e sustentáveis, além de discutir o impacto dessa transformação na vida das pessoas e oportunidades a serem exploradas.`,
    date: "09/05",
    time: "19:00-20:30",
    place: "Online",
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_NzNkNzk4YzgtY2VhOC00M2M0LWEyZDEtMWY0YzZlNjcwYmMy%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d"
  },

  { 
    title: 'De Ciência de Dados a Engenharia de Inteligência Artificial: um achismo de como será o futuro',
    instructor: 'João Paulo Martins',
    institution: 'Sorcero',
    desc: `Como as profissões de Cientista de Dados e Engenheiro de Inteligência Artificial estão moldando o futuro não só da tecnologia, mas também de todas as outras profissões.`, 
    date: '09/05',
    time: '19:00-20:30',
    place: 'Auditório 3 (Área II)'
   },
  
  { 
    title: 'Como soft skills podem lhe garantir uma vaga ou salvar o seu emprego',
    instructor: 'Camila Christina Moreira.',
    institution: 'Accenture Brasil.',
    desc: `Soft skills é um tema bastante popular na gestão de carreira, mas a aplicação desse tema na realidade não considerado algo fácil. Será discutido a forma de compreender essa jornada de aprendizado constante e situações que podem nos trazer uma oportunidade ou fechar uma porta.`, 
    date: '08/05',
    time: '20:30-22:00',
    place: 'Auditório 1 (Área II)'
   },
  

  {
    title: 'Como se comportar em uma entrevista de estágio',
    instructor: 'DANILO GREGÓRIO.',
    institution: 'Marcca Engenharia',
    desc: `O palestrante é responsável pelo departamento Gente e Cultura da Marcca Engenharia e faz a seleção de estagiários para os diversos departamentos da empresa, ele trará dicas de como se comportar no momento de uma entrevista de estágio, como fazer seu currículo ficar mais atrativo para o entrevistador, e quais plataformas podem ajudar a alcançar seu estágio.`,
    date: '08/05',
    time: '18:00-19:30',
    place: "Online",
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_MTIxYzQwZTAtNmJiYS00ZmQxLWI5NTktNDQzODhlMjYzYTk0%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d"
   
  },

  {
    title: 'Programa de Licenciatura em Gestão do Transporte Aéreo da Atlantica, Portugal',
    instructor: 'Miguel Moreira',
    institution: '',
    desc:`O palestrante apresentará o curso de Licenciatura em Gestão do Transporte Aéreo da Universidade Atlantica, Portugal com vistas ao inicio de um intercambio internacional entre esta universidade e a PUC-Goiás.`,
    date: '09/05',
    time: '09:00-10:30',
    place: "Online",
    link:"https://teams.microsoft.com/l/meetup-join/19%3ameeting_MmY3NGI0YjYtMzMyNS00MmE1LTkzY2QtZjk5OGI2NjZlZDMw%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d"
   
  },

  {
    title: 'Setor Aeroagrícola Brasileiro',
    instructor: 'Gabriella Meireles',
    institution: '',
    desc: `Apresentação do setor aeroagricola do Brasil.`,
    date: '08/05',
    time: '09:00-10:30',
    place: "Online",
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_ZWM0NGViNDItMTFlMi00MGQwLTliZWItNWJhY2ExYmM0MjQ5%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d"
  
  },
  {
    title: 'O poder do inglês no Marketing Digital: Uma visão integrada com a Engenharia de Produção',
    instructor: 'Rener Baptista',
    institution: 'CEO na iNexxus Global',
    desc: `Nesta palestra, exploramos a importância do inglês no marketing digital e como isso está associado à engenharia de produção. Discutimos como o inglês pode ser a chave para desbloquear oportunidades no mercado global e como ele pode ajudar a melhorar a comunicação com clientes e colaboradores estrangeiros. Também falamos sobre a relação entre o inglês e a engenharia de produção, mostrando como a fluência no idioma pode ajudar a entender melhor processos produtivos e gerar insights valiosos. Ao final da palestra, os participantes terão uma compreensão mais profunda da importância do inglês no contexto do marketing digital e da engenharia de produção, e estarão equipados com ferramentas e insights para avançar em suas carreiras.`,
    date: '10/05',
    time: '19:00-20:30',
    place: 'Online',
    link: 'https://teams.microsoft.com/l/meetup-join/19%3ameeting_OWU1Yjk1YzgtNmNiMC00NDRjLThkMTctNDNjOGU0MDdjZDg2%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d'
  },
  {
    title: 'IMPACTO NO LONGO PRAZO DA MOBILIDADE ELÉTRICA NO SISTEMA ELÉTRICO BRASILEIRO',
    instructor: 'Rafael Bomaro Ferreira',
    institution: 'AXS Energia – Florianópolis – SC',
    desc: `Com o aumento das vendas de carros elétricos e híbridos surge a preocupação em relação à infraestrutura elétrica existente, e como faremos para recarregar tantos carros elétricos no futuro, um dos estudos que começou em 2016 pela Nissan e pela Renault foi o chamado "Vehicle-to-grid" (veículo para a rede) ou V2G onde as baterias do carro podem fornecer energia para uma casa ou região por um determinado tempo. A Geração Distribuída-GD tem um papel fundamental na utilização das baterias veiculares para armazenamento de energia (segunda vida útil), porém precisa-se se pensar também em qual será a visão de médio e longo prazo do Setor Elétrico de uma rede de transporte eletrificada.`,
    date: '10/05',
    time: '20:30-22:00',
    place: "Online",
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_NjQ3OTcwNDMtMTVjYS00YTk3LTg1ZWItMDkwZmMzM2NkNWZh%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d"
  
  },

  {
    title: 'Perícia agronômica e assistência técnica em perícia',
    instructor: 'Eliezer Furtado de Carvalho',
    institution: 'Perito judicial',
    desc: `A atividade de perícia relacionada a imóveis rurais e/ou atividades e produtos rurais, na sua quase totalidade, são da competência exclusiva do engenheiro agrônomo. Trata-se de atividade que possibilita melhores níveis de remuneração, quando comparada com outras áreas de atuação dos profissionais de agronomia.`,
    date: '10/05',
    time: '10:00-11:30',
    place: 'Presencial: Auditório Marisa Roriz (Área III)'
  
  },
  {
    title: 'Dados real-time no BigQuery usando CDC',
    instructor: 'Egio Arruda',
    institution: 'EasyCrédito/FitBank',
    desc: `Esta palestra é um caso real de como utilizar o BigQuery como Data Warehouse de alto desempenho com ingestão de dados real-time usando CDC (Change Data Capture) para impacto mínimo nos bancos de dados de produção e baixo custo.`,
    date: '08/05',
    time: '17:00-18:30',
    place: 'Online',
    link: "https://teams.microsoft.com/l/meetup-join/19%3ameeting_MTMzZDY1ZjAtZTY0Yi00MDU1LTg0ZjUtMDE1Yjk5M2I1Yjcx%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d"
  
  },
  {
    title: 'IARA: Centro de Pesquisa Aplicada em Inteligência Artificial para Cidades Inteligentes',
    instructor: 'André Carlos Ponce de Leon Ferreira de Carvalho',
    institution: 'USP - São Carlos',
    desc: `Assim como avanços econômicos e sociais permitem que as pessoas vivam mais e melhor, eles também aumentam a consciência de que estes avanços precisam ocorrer de uma forma mais rápida, sustentável e inclusiva. Isso gera uma crescente demanda por melhor qualidade de vida, tanto em regiões urbanas quanto rurais. Um dos principais caminhos para este aumento passa pela incorporação de novas tecnologias, que permitam, por exemplo, a transformação de cidades em cidades inteligentes. Uma cidade inteligente é uma cidade que melhor atende às necessidades de sua população, sendo, ao mesmo tempo, igualitária, inclusiva e sustentável. Dentre as tecnologias que estão sendo adotadas, merecem destaque aquelas baseadas em inteligência artificial.  Nesta palestra apresentarei o centro nacional de pesquisa em inteligência artificial IARA (Inteligência Artificial Recriando Ambientes), selecionado em chamada nacional para centros brasileiros de pesquisa em Inteligência Artificial Aplicada, da FAPESP, MCTI e CGI.br . Apresentarei ainda as primeiras iniciativas do centro, que funciona como uma rede nacional, representada nas 5 regiões do país. Ao final, falarei brevemente sobre algumas das pesquisas em inteligência artificial aplicada realizadas no ICMC USP.`,
    date: '09/05',
    time: '17:00-18:30',
    place: 'Online: YouTube',
    link: "https://www.youtube.com/watch?v=JtRUBz5-F7A"
  },
  {
    title: 'Cidades Inteligentes',
    instructor: 'Hemmanoel Feitosa e Silva',
    institution: 'Secretaria Municipal de Inovação, Ciência e Tecnologia - SICTEC',
    desc: `Cidades inteligentes, ou smart cities, são aquelas que utilizam tecnologias avançadas para melhorar a qualidade de vida dos seus habitantes, otimizar a gestão dos serviços públicos e promover a sustentabilidade ambiental e econômica. Essas tecnologias incluem sensores, dispositivos de internet das coisas, sistemas de análise de dados, entre outros, que permitem a coleta e o processamento de informações em tempo real, facilitando a tomada de decisões e a otimização dos recursos.`,
    date: '08/05',
    time: '09:00-10:30',
    place: 'Auditório 1 (Área II)'
  
  },
  {
    title: 'NEUROARQUITETURA',
    instructor: 'Lorí Crízel',
    institution: 'Instituto Politécnico di Milano (Itália)',
    desc: `DIÁLOGO DIRIGIDO`,
    date: '10/05',
    time: '10:30-12:00',
    place: 'Online',
    link: 'https://teams.microsoft.com/l/meetup-join/19%3ameeting_NmMwZDk2YjMtZDljNC00NTZlLTllN2QtMTBkMjA3Njg5ODJk%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d'
  
  },

  {
    title: 'Enade engenharia civil 2023',
    instructor: 'Marta Pereira da Luz, Rosana Brandão e Benjamin Jorge',
    institution: 'PUC Goiás',
    desc: `Informes gerais sobre Enade 2023 para o curso de Engenharia civil`,
    date: '08/05',
    time: '19:00-20:30',
    place: 'Auditório 2 (Área II)'
  
  },

  {
    title: 'Energia Solar Fotovoltaica: Histórico, Desafios e Tendências Tecnológicas da Energia Limpa e Renovável',
    instructor: 'Gabriel Mendonça de Paiva',
    institution: 'Photon Energia LTDA',
    desc: `A energia solar fotovoltaica será abordada sobre aspectos históricos e de perspectivas futuras dos pontos
    de vista teórico, mercadológico e de oportunidades que podem surgir nas Engenharias relacionadas ao uso da energia solar fotovoltaica e das tecnologias relacionadas`,
    date: '10/05',
    time: '09:00-10:00',
    place: 'Auditório 1 (Área II)'
  
  },

  {
    title: 'A carreira do profissional de gestão de projetos - desafios e oportunidades',
    instructor: 'Lhiego Rodrigues de Paula',
    institution: 'Project Management Institute (PMI), Goiás, Go',
    desc: `Quer saber quais são os desafios e as oportunidades de uma carreira em gestão de projetos? Então essa palestra é para você! Vamos falar sobre as habilidades necessárias para superar esses desafios, tais como liderança, comunicação, planejamento e resolução de problemas. Vamos abordar o que você precisa saber para se manter competitivo no mercado e oferecer insights valiosos para ajudá-lo a navegar nesse campo tão dinâmico.`,
    date: '08/05',
    time: '19:00-20:30',
    place: 'Online',
    link: 'https://teams.microsoft.com/l/meetup-join/19%3ameeting_OGJhODNjYTAtNGM5Ni00Y2M5LWJlYWQtY2RjMWI2YzMzNmU1%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d'
  
  },

  {
    title: '',
    instructor: 'Ivan Lourenço Costa ',
    institution: 'Project Management Institute (PMI), Goiás, Go',
    desc: `Quer saber quais são os desafios e as oportunidades de uma carreira em gestão de projetos? Então essa palestra é para você! Vamos falar sobre as habilidades necessárias para superar esses desafios, tais como liderança, comunicação, planejamento e resolução de problemas. Vamos abordar o que você precisa saber para se manter competitivo no mercado e oferecer insights valiosos para ajudá-lo a navegar nesse campo tão dinâmico.`,
    date: '08/05',
    time: '08:00-09:30',
    place: 'Auditório 3 (Área II)',
    warning: "A carreira do profissional de gestão de projetos - desafios e oportunidades CANCELADA ",
    

  },

  {
    title: "Desenvolvendo Habilidades Sociais e de Liderança, por meio da Experiência de Monitoria: Celebrando 50 Anos na PUC Goiás",
   instructor: "Marília Rabelo Holanda Camarano",
    institution: "PUC Goiás",
    desc: `Mesa redonda da Monitoria como processo de desenvolvimento de liderança e soft skills, para a o futuro profissional`,
    date: "10/05",
    time: '08:00-09:30',
    place: 'Auditório 2 (Área II)',
  },


  {
    title: "Apresentação dos artigos e resumos expandidos na II JCPOLI",
    instructor: "Matheus Fernandes, Estevão Cavalcante e Hianka Rodrigues",
    institution: "PUC Goiás",
    desc: "Apresentação dos artigos aceitos na II JCPOLI: Artigo:  Predição da precificação de commodities pecuárias utilizando redes neurais artificiais Autor(a): Matheus Fernandes. Artigo: Análise preditiva com redes neurais convolucionais para o geoprocessamento de imagens Autor(a): Estevão Cavalcante. Artigo: Uso das normas NBR ISO/IEC 27017 e 27018 para garantir a segurança da computação em nuvem Autor(a): Hianka Rodrigues",
    date: "09/05",
    time: "10:45-12:15",
    place: "Auditório Marisa Roriz (Área III)",
  },

  {
    title: "Como a Engenharia Mecatrônica contribuiu para a minha atuação em Animação 3D",
    instructor: "Lavio Ribeiro Fidelis Neto",
    institution: "Ubisoft Toronto",
    desc: "A gestão de tempo e projetos foi fundamental para o desenvolvimento das minhas habilidades em animação 3D e transferir essas habilidades para a criação de animações foi natural. Criei um fluxo de trabalho que envolve o planejamento cuidadoso de cada cena e a definição de prazos realistas, garantindo que o resultado final atenda às expectativas do diretor de animação.",
    date: "09/05",
    time: "18:00-19:00",
    place: "Online",
    link:'https://teams.microsoft.com/l/meetup-join/19%3ameeting_OGEzZjk2ZWQtMGFmMi00NjU0LWFlZDUtNjhiMjhhN2E1NzIy%40thread.v2/0?context=%7b%22Tid%22%3a%2273319f42-8908-4b89-9f8d-558cf4d5d776%22%2c%22Oid%22%3a%224d5d6768-2ee9-4adc-ac86-4da09deed785%22%7d'
  },

]

const Palestras_Producao = [
  
]

const Palestras_Design = [

]

const Palestras_Caer = [
  
]

const Palestras_Mestrado = [
  
  
  
]



const Palestras_Agronomia = [
 
]


const Palestras_Civil = [

]

const Palestras_ArquiteturaUrbanismo = [
  
 
]

const Palestras_ControleAutomacao = [
  
  
]

const Palestras_IniciacaoCientifica = [
  
]


Palestras = Palestras.sort((a, b) => {
  if(a.date < b.date) return -1;
  if(a.date > b.date) return 1;
  if(a.time < b.time) return -1;
  if(a.time > b.time) return 1;
  if(a.title < b.title) return -1;
  if(a.title > b.title) return 1;
  return 0;
});

export const Palestras_Cursos = [

  {
    curso: 'Ciência da Computação',
    palestras: Palestras,
  },
  /*
  {
    curso: 'Agronomia',
    palestras: Palestras_Agronomia,
  },
  {
    curso: 'Arquitetura e Urbanismo',
    palestras: Palestras_ArquiteturaUrbanismo,
  },
  {
    curso: 'Ciências Aeronáuticas',
    palestras: Palestras_Caer,
  },
  {
    curso: 'Civil',
    palestras: Palestras_Civil,
  },
  {
    curso: 'Engenharia de Controle e Automação',
    palestras: Palestras_ControleAutomacao,
  },   
  {
    curso: 'Engenharia de Produção',
    palestras: Palestras_Producao,
  }, 
  {
    curso: 'Design',
    palestras: Palestras_Design,
  },  
  {
    curso: 'Mestrado',
    palestras: Palestras_Mestrado,
  },
  {
    curso: 'Iniciação Ciêntifica',
    palestras: Palestras_IniciacaoCientifica,
  },
  */  
]